module.exports = __webpack_public_path__ + "static/img/2@2x.58375f1c.png";